export default function EFMicroware(props: any) {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Microware_icon">
                    <rect id="矩形备份-25" x="0" y="0" width="30" height="30"></rect>
                    <g
                        id="编组-40"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(0.750000, 6.750000)"
                        stroke={props.color || '#FFFFFF'}
                        strokeWidth="1.03448276"
                    >
                        <path
                            d="M27.1246503,17.2498637 L1.37489926,17.2498637 C0.995259539,17.2498637 0.651196965,17.0945005 0.402607252,16.8432844 C0.153567196,16.5925227 0,16.2459082 0,15.8624971 L0,1.38782086 C0,0.95307632 0.197700877,0.56512247 0.507537331,0.310726503 C0.744418111,0.116749578 1.04614837,0 1.37489926,0 L27.1246503,0 C27.471415,0 27.7880066,0.129469377 28.0298412,0.342980277 C28.3180611,0.596921966 28.5,0.970793182 28.5,1.38782086 L28.5,15.8624971 C28.5,16.261808 28.3329224,16.6215965 28.064968,16.8746296 C27.8190803,17.1076745 27.4885281,17.2498637 27.1246503,17.2498637 Z"
                            id="Stroke-57"
                        ></path>
                        <line x1="20.625" y1="0" x2="20.625" y2="17.25" id="Stroke-59"></line>
                        <polygon id="Stroke-61" points="2.51465835 14.7677684 18.2273482 14.7677684 18.2273482 2.76776843 2.51465835 2.76776843"></polygon>
                        <line x1="21" y1="13.125" x2="28.5" y2="13.125" id="Stroke-63"></line>
                        <path
                            d="M26.25,3.75 C26.25,4.57840154 25.5784944,5.25 24.7497926,5.25 C23.9215056,5.25 23.25,4.57840154 23.25,3.75 C23.25,2.92159845 23.9215056,2.25 24.7497926,2.25 C25.5784944,2.25 26.25,2.92159845 26.25,3.75 Z"
                            id="Stroke-64"
                        ></path>
                        <path
                            d="M26.25,9 C26.25,9.82840152 25.5784945,10.5 24.7497927,10.5 C23.9215056,10.5 23.25,9.82840152 23.25,9 C23.25,8.17118359 23.9215056,7.5 24.7497927,7.5 C25.5784945,7.5 26.25,8.17118359 26.25,9 Z"
                            id="Stroke-65"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
